import { RouterProvider } from "react-router-dom";
import { AuthContext } from "./hooks/use-auth";
import { useAuthProvider } from "./hooks/use-auth";
import { router } from "./router";

export function App(): React.JSX.Element {
  const auth = useAuthProvider();

  return (
    <AuthContext.Provider value={auth}>
      <RouterProvider router={router} />
    </AuthContext.Provider>
  );
}
